export default "__VITE_ASSET__47c2dcbe__"